import { render, staticRenderFns } from "./EquipoTrabajoComponent.vue?vue&type=template&id=5098a340"
import script from "./EquipoTrabajoComponent.vue?vue&type=script&lang=js"
export * from "./EquipoTrabajoComponent.vue?vue&type=script&lang=js"
import style0 from "./EquipoTrabajoComponent.vue?vue&type=style&index=0&id=5098a340&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports